import {
  request,
  useEndpointsContext,
  type CustomerNetAcquisitionLimitConfig,
  type MinimalSubscriptionResponse,
} from '@talos/kyoko';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const ACQUISITION_LIMIT_CONFIG_ID = 'ACQUISITION_LIMIT_CONFIG';

export function useAcquisitionLimitConfigQuery() {
  const { orgApiEndpoint } = useEndpointsContext();

  return useQuery<CustomerNetAcquisitionLimitConfig>({
    enabled: !!orgApiEndpoint,
    queryKey: [ACQUISITION_LIMIT_CONFIG_ID],
    queryFn: async () =>
      request<MinimalSubscriptionResponse<CustomerNetAcquisitionLimitConfig>>(
        'GET',
        `${orgApiEndpoint}/customer-risk/net-acquisition/config`
      ).then(response => {
        return response.data[0];
      }),
  });
}

export function useAcquisitionLimitConfigMutation() {
  const { orgApiEndpoint } = useEndpointsContext();
  const queryClient = useQueryClient();

  if (!orgApiEndpoint) {
    throw new Error('No org api endpoint defined!');
  }

  return useMutation<CustomerNetAcquisitionLimitConfig, undefined, CustomerNetAcquisitionLimitConfig>({
    mutationFn: async newConfig =>
      request<MinimalSubscriptionResponse<CustomerNetAcquisitionLimitConfig>>(
        'POST',
        `${orgApiEndpoint}/customer-risk/net-acquisition/config`,
        newConfig
      ).then(res => res.data[0]),

    onSuccess: data => {
      queryClient.setQueryData([ACQUISITION_LIMIT_CONFIG_ID], data);
    },
  });
}
